export const defaultHiddenEmailStart = "wademo.hidden-";
